import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import AdminLiquidSurface from "./AdminLiquidSurface"

export default function AdminPageHeader({
  title,
  subtitle,
  actions,
  liquid = false,
}) {
  const content = (
    <Row
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Column gap={0.5}>
        <Typography
          variant="h2"
          sx={{
            color: "#0f1216",
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </Column>
      {actions}
    </Row>
  )

  if (!liquid) {
    return (
      <Column gap={0.75} sx={{ mb: 3 }}>
        {content}
      </Column>
    )
  }

  return (
    <AdminLiquidSurface variant="panel" sx={{ mb: 3, p: { xs: 2, sm: 2.5 } }}>
      {content}
    </AdminLiquidSurface>
  )
}

AdminPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  liquid: PropTypes.bool,
}
